import React, { useContext, useEffect, useState } from 'react'
import {
  RewardProgramDetailsDto,
  RewardProgramDetailsUpdateDto,
} from '@/api/Trading-Accounts/Types/RewardProgramDto'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { RewardProgramTab } from '@/routes/Marketing/RewardsHub/RewardPrograms/ResolveRewardPrograms'
import { RewardProgramNavigation } from '@/routes/Marketing/RewardsHub/RewardPrograms/RewardProgramNavigation'
import { useApiClient } from '@/utils/api/ApiClient'
import { TradingAccountsApiClient } from '@/utils/api/tradingAccountsApi'
import { useCallbackWithForceRefresh } from '@/utils/api/useCallbackWithForceRefresh'
import { useFetchOneWithFetchingUpdate } from '@/utils/api/useFetchOneWithFetchingUpdate'
import { links } from '@/utils/featureToggles'
import { successToast, ToastContext } from 'components/Toast/Toast'

import { RewardProgramEditForm } from './RewardProgramEditForm'

interface OuterProps {
  data: RewardProgramDetailsDto
  afterSubmit(): void
}

const RewardProgramDetailsPage: React.FC<OuterProps> = ({ data, afterSubmit }) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)
  const { callback: rewardsCallback } = useCallbackWithForceRefresh(() => {
    return tradingAccountsApiClient.getRewards({
      pageSize: 1000,
    })
  }, [])
  const { callback: rewardsProgramCallback } = useCallbackWithForceRefresh(() => {
    return tradingAccountsApiClient.getRewardPrograms({
      pageSize: 1000,
    })
  }, [])
  const { data: rewardsList } = useFetchOneWithFetchingUpdate(rewardsCallback)
  const { data: rewardsProgramList } = useFetchOneWithFetchingUpdate(rewardsProgramCallback)
  const setToast = useContext(ToastContext)

  const [crumbs, setCrumbs] = useState([
    { title: 'Reward Programs', link: links.rewardPrograms.url },
  ])

  const handleSubmit = async (values: RewardProgramDetailsUpdateDto) => {
    await tradingAccountsApiClient.updateRewardProgramDetails(data.id, values)
    setToast(successToast('Reward Program updated successfully.'))
    afterSubmit()
  }

  useEffect(() => {
    if (data) {
      const [crumb1] = crumbs
      setCrumbs([crumb1, { title: data.internalName, link: '' }])
    }
  }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Breadcrumbs crumbs={crumbs} />
      <RewardProgramNavigation data={data} tab={RewardProgramTab.DETAILS} />
      <RewardProgramEditForm
        rewardProgramList={rewardsProgramList}
        rewardsList={rewardsList}
        initialValues={data}
        onSubmit={handleSubmit}
      />
    </>
  )
}

export default RewardProgramDetailsPage
